// extracted by mini-css-extract-plugin
export default {"content":"AddingCode_content__nEsT9","button":"AddingCode_button__4RT4T"};